import { useEffect, useState, useRef, useContext } from "react";
import { Nav, Tab } from "react-bootstrap";
import { Navigate, useParams } from "react-router-dom";
import Layout from '../../layout/default';
import Block from "../Block/Block"
import { toInitials } from "../../utilities"
import { Image, Icon, Schedule, Media, MediaGroup, MediaText } from "../../components"
import Spinner from 'react-bootstrap/Spinner';
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";


import PersonalDetails from "./PersonalDetails";
import AgentPayRates from "./AgentPayRates";
import AgentQualifations from "./AgentQualifations";
import EmploymentDetails from "./EmploymentDetails";
import AgentLoginDetails from "./AgentLoginDetails";
import AddTask from "../Tasks/AddTask";
import DocumentManagement from "../Storage/DocumentManagement";
import ProfileImageUploader from "../Storage/ProfileImageUploader";
import { useApiClient } from "../../ApiService/useApiClient";
import { AppContext } from "../../context/AppContext";



const Staff = ({restrictedMode}) => {

    let {id} = useParams();

    const api = useApiClient();
    const {SiteConfig} = useContext(AppContext);



    if(restrictedMode) id = SiteConfig.CURRENT_USER_ID;

    const baseURL = "HMCareStaff/staffdetail/"+id;
    
    const [data, setdata] = useState(null);
    const [error, setError] = useState(null);
    const[UserProfile, setUserProfile] = useState('/images/avatar/a.jpg')
    const[ShowProfileImageUploadPopup, setShowProfileImageUploadPopup] = useState(false);


    const dataFetchedRef = useRef(false);

    const user = {
        theme : 'danger-soft',
        avatar : '/images/avatar/a.jpg',
        name : "",
        role : "",
      }


      const showImageUploadPopup = ()=>{       
        setShowProfileImageUploadPopup(true);        
    }
   

    useEffect(()=> {

        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
    
        api.get(baseURL).then((Response)=>{
            setdata(Response.data);

            setUserProfile(Response.data.profileimage);
           // console.log(Response.data);

        }).catch(error => {
            setError(error);
        });             

    },[]);

    if (error) 
        {      
          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return "Error: ${error.message}";
        }


    if(!data) return (<Layout title="Staff Management" content="container"><Spinner animation="border" variant="primary" /></Layout>);
            




    if(data) return (
    <Layout title="Staff Management" content="container">
    
    {!restrictedMode && <Breadcrumb className="breadcrumb-arrow">
      <Breadcrumb.Item><Link to={`/`}>Dashboard</Link></Breadcrumb.Item>
      <Breadcrumb.Item><Link to={`/staff-manage/staff/`}>staff list</Link></Breadcrumb.Item>      
      <Breadcrumb.Item active>Staff Details</Breadcrumb.Item>
    </Breadcrumb>}

    {restrictedMode && <Breadcrumb className="breadcrumb-arrow">
      <Breadcrumb.Item><Link to={`/`}>Dashboard</Link></Breadcrumb.Item>
      <Breadcrumb.Item active>My Account</Breadcrumb.Item>
    </Breadcrumb>}
    
    <Block.Head>
            <Block.HeadBetween className="align-items-start">
                <Block.HeadContent>
                    <div className="d-flex flex-column flex-md-row align-items-md-center">
                        <Media size="huge" shape="circle" variant={user.theme && user.theme}>
                            {/* {user.avatar ? 
                                <Image src={user.avatar} staticImage thumbnail alt="user"/> :
                                <span className="fw-medium">{toInitials((data.agent.title??'') +' '+ data.agent.agentFname +' '+ data.agent.agentLname)}</span>
                            } */}
                            <Image src={UserProfile} staticImage thumbnail alt="user"/>
                        </Media>
                        {data.agent && 
                        <div className="mt-3 mt-md-0 ms-md-3">
                            <h3 className="title mb-1">{(data.agent.title??'') +' '+ data.agent.agentFname +' '+ data.agent.agentLname} (#{id})</h3>
                            <span className="small">{data.jobRole?.jobRoleName}</span>
                            {data.isAdmin == "1" && <span className="small">Admin Staff</span> }
                            {/* {data.isAdmin !== "1" && <span className="small">Carer</span> } */}
                            
                        </div>
                        }
                    </div>
                    <div style={{}} onClick={showImageUploadPopup}><Icon name="edit-alt"></Icon><span style={{fontWeight:"bold", fontSize:"14px",cursor: "pointer"}}>Edit</span></div>
                </Block.HeadContent> 
                 
            </Block.HeadBetween>
            
    </Block.Head>

    <Tab.Container id="client-details" defaultActiveKey="default-personal">
    <Nav variant="tabs" className="nav-tabs-s1 mb-3">
        <Nav.Item>
            <Nav.Link eventKey="default-personal">Personal</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-skills">Skills/Qualifications</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-employment">Employment</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-rates">Pay Rates</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-docs">Documents</Nav.Link>
        </Nav.Item> 
        <Nav.Item>
            <Nav.Link eventKey="default-login">Login & Access Details</Nav.Link>
        </Nav.Item>       
        {/* <Nav.Item>
            <Nav.Link eventKey="default-add">Add Task</Nav.Link>
        </Nav.Item>        */}
    </Nav>
    <Tab.Content>
        <Tab.Pane eventKey="default-personal">
            <PersonalDetails datainfo={data}/>    
        </Tab.Pane>
        <Tab.Pane eventKey="default-skills">
            <AgentQualifations data={data.agentQualifications} AgentID ={data.agent.agentId}/>
        </Tab.Pane>
        <Tab.Pane eventKey="default-employment">
            <EmploymentDetails datainfo={data}/>    
        </Tab.Pane>      
        <Tab.Pane eventKey="default-rates">
            <AgentPayRates RateData={data.agentPayRates} MainCustomerID={data.agent.agentId}/>    
        </Tab.Pane>        
        <Tab.Pane eventKey="default-docs">            
            {/* <Staffdocuments clientID={data.agent.agentId} /> */}
            <DocumentManagement sID={data.agent.agentId} context={"staff"} />
        </Tab.Pane>
        <Tab.Pane eventKey="default-login">
            <AgentLoginDetails data={data.agent}/>    
        </Tab.Pane>    
        {/* <Tab.Pane eventKey="default-add">
            <AddTask />
        </Tab.Pane> */}
    
    </Tab.Content>
</Tab.Container>                        

<ProfileImageUploader 
        ShowProfileImageUploadPopup={ShowProfileImageUploadPopup} 
        setShowProfileImageUploadPopup={setShowProfileImageUploadPopup} 
        setUserProfile = {setUserProfile} 
        customerId={data.agent.agentId} 
    />

    </Layout>
  )
}

export default Staff